<template>
  <!-- 电脑端-下载提示UI -->
  <div
    id="u_c_KZMJ21"
    class="normal u_c_KZMJ21"
    data-gtm="gtm-click-cta"
    v-show="pageData.isDownloadExe"
    @click="u_c_KZMJ21_event_WY5Z26($event)"
  ></div>
</template>
<script>
import { reactive, provide, inject, onMounted, watch, ref, computed } from "vue"
import Language from "@/hooks/language.js"
import Router from "@/hooks/router.js"
import bridge from "@/utils/sdkBridge.js"
import * as request from "@/api/request"
import * as utils from "@/utils"
import * as _ from "lodash"

export default {
  name: "",
  components: {},
  setup() {
    const { curLang, getLangTxt, langData } = Language()
    const routerData = inject("routerData", {})
    const pageData = inject("pageData", {})
    const COMP_DATA_LANG = { default: {}, "vi-VN": {} }
    const compData = reactive(
      COMP_DATA_LANG[curLang] || COMP_DATA_LANG["vi-VN"] || {}
    )

    const router = Router()

    // 自定义setup - 开始
    const gaClickUpload = inject("gaClickUpload", () => {})
    // 下载提示UI的click事件
    const u_c_KZMJ21_event_WY5Z26 = async (e) => {
      try {
        let gtm_filter_res = utils.getCookie(
          `zz_gtm_filter_${pageData.gameId}_cta`
        )
        if (!gtm_filter_res) {
          gaClickUpload("gtm-click-cta")
          if (pageData.gameId) {
            utils.setCookie(`zz_gtm_filter_${pageData.gameId}_cta`, 1, 30)
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    // 自定义setup - 结束
    return { u_c_KZMJ21_event_WY5Z26, pageData, routerData, compData, langData }
  },
}
</script>
<style lang="scss" scoped>
.default {
  .u_c_KZMJ21.normal {
    position: fixed;
    width: 18.8vh;
    height: 22.41vh;
    background-image: url(https://gimages.olgamevn.com/aws_s3/img?s=/platform/one_image/2022/08/16602889213732.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    bottom: 1.85vh;
    left: 0.28vh;
    animation: float1 1s infinite;
  }
  @keyframes float1 {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0);
    }
  }
}
.vi-VN {
  .u_c_KZMJ21.normal {
    position: fixed;
    width: 18.8vh;
    height: 22.41vh;
    background-image: url(https://gimages.olgamevn.com/aws_s3/img?s=/platform/one_image/2022/10/16662596723570.png);
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    bottom: 1.85vh;
    left: 0.28vh;
    animation: float1 1s infinite;
  }
  @keyframes float1 {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(20px);
    }
    100% {
      transform: translateY(0);
    }
  }
}
</style>
